import { PageButtonSchema } from '@/views/sports/components/PageButton/styles/PageButton.styles';

export const pageButtonStyles: PageButtonSchema = {
  button: {
    variant: 'outline',
    fontSize: '2xs',
    height: 'auto',
    lineHeight: 'inherit',
    borderRadius: 'base',
    borderColor: 'white',
    textShadow: '0px 1px 2px rgba(0, 0, 0, 0.40)',
    textTransform: 'uppercase',
    px: '3',
    py: '1',
    color: 'white',
    sx: {
      '&&': {
        fontWeight: 'bold',
        bgImage: 'none',
        color: 'white',
      },
      svg: {
        bg: 'transparent',
        p: '0.5',
        color: 'white',
        borderRadius: 'sm',
      },
    },
    _hover: {
      color: 'gamma.500',
    },
  },
};
